import React, { Component } from 'react'
import { withStyles } from "@material-ui/core/styles";
import { Grid,Chip } from '@material-ui/core';
import LocalMovies from "@material-ui/icons/LocalMovies";


const styles = theme => ({
    root: {
        paddingLeft: theme.spacing(1) * 2
    },
    cardContainer: {
        marginTop: theme.spacing(1) * 2
    },
    chip: {
        margin: theme.spacing(1),
        color: 'darkblue'
    },
    
});

class VideoList extends Component {
    render() {
        const { classes, fields: list } = this.props;

        return (
            <Grid container className={classes.root} >
                {list.map((field, index, fields) =>
                    <Grid className={classes.cardContainer} item key={index} >
                        <Chip
                            icon={<LocalMovies />}
                            label={`video${index+1}`}
                            onDelete={() => { fields.remove(index) }}
                            className={classes.chip}
                            variant="outlined"
                        />
                    </Grid>
                )}

            </Grid>
        )
    }
}

export default withStyles(styles)(VideoList);